import React from 'react';
import { ModuleCard } from '../components/ui/ModuleCard';
import { MODULES } from '../data/mockData';
type HomePageProps = {
  onModuleSelect: (id: string) => void;
};
export function HomePage({
  onModuleSelect
}: HomePageProps) {
  return <div className="min-h-screen bg-white" data-id="element-450">
      {/* Header */}
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-451">
        <div className="flex justify-between items-center mb-12" data-id="element-452">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-453">
            古诗音乐实验室
          </h1>
        </div>

        {/* Module Grid - Chrome Music Lab style: 3 columns on desktop */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-454">
          {MODULES.map(module => <ModuleCard key={module.id} module={module} onClick={onModuleSelect} data-id="element-455" />)}
        </div>
      </div>
    </div>;
}